module.exports = __webpack_public_path__ + "static/media/teampulse-start-long.5f88bb1b.svg";